(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fairy-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fairy-size-guide')) {
  customElements.define('fairy-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const trigger = this.querySelector('.fp-size-guide__trigger');
      const dialog = this.querySelector('dialog');
      const close = this.querySelector('.fp-size-guide__close');
      if (!trigger || !dialog || typeof dialog.showModal !== 'function') return;
      trigger.hidden = false;
      trigger.addEventListener('click', () => {
        if (dialog.open) return;
        this.previousOverflow = document.body.style.overflow;
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        close.focus();
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        const box = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow || '';
        if (trigger.isConnected) trigger.focus();
      });
    }
    disconnectedCallback() {
      if (this.querySelector('dialog')?.open) document.body.style.overflow = this.previousOverflow || '';
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
